"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var react_redux_firebase_1 = require("react-redux-firebase");
var redux_1 = require("redux");
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var Cell_1 = __importDefault(require("atomicComponents/molecules/Table/Cell"));
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var FooterMaker_1 = __importDefault(require("containers/TableMaker/FooterMaker"));
var HeaderMaker_1 = __importDefault(require("containers/TableMaker/HeaderMaker"));
var HoCs_1 = require("utils/HoCs");
var RowMaker_1 = __importDefault(require("../../TableMaker/RowMaker"));
var hooks_1 = require("./hooks");
var Menu_1 = __importDefault(require("./Menu"));
var Preview_1 = __importDefault(require("./Preview"));
var tableConf_1 = require("./tableConf");
var Header = (0, HeaderMaker_1.default)(tableConf_1.namingTableConf);
var Row = (0, RowMaker_1.default)(tableConf_1.namingTableConf);
var Footer = (0, FooterMaker_1.default)(tableConf_1.namingTableConf);
var Naming = function () {
    var _a = __read((0, hooks_1.useGetServices)(tableConf_1.namingTableConf.extractors), 7), sortedServices = _a[0], servicesList = _a[1], selectedService = _a[2], setSelectedServiceId = _a[3], searchText = _a[4], setSearchText = _a[5], loaderRef = _a[6];
    if (!(0, react_redux_firebase_1.isLoaded)(sortedServices)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled - Naming", description: "Tools database" }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", height: "100%", pb: 4 }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ width: selectedService ? 400 : 1400, display: "flex", flexDirection: "column" }, { children: [(0, jsx_runtime_1.jsx)(Menu_1.default, { searchText: searchText, setSearchText: setSearchText, hasPreview: !!selectedService, setSelectedServiceId: setSelectedServiceId }), (0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ maxWidth: 1400, px: 4 }, { children: [(0, jsx_runtime_1.jsx)(Header, { isPartialView: !!selectedService }), (0, jsx_runtime_1.jsxs)(TableBody_1.default, __assign({ width: "100%" }, { children: [servicesList === null || servicesList === void 0 ? void 0 : servicesList.map(function (srv) { return ((0, jsx_runtime_1.jsx)(Row, { item: srv, onClickRow: function (_a) {
                                                    var id = _a.id;
                                                    return setSelectedServiceId(id);
                                                }, isPartialView: !!selectedService }, srv.id)); }), !(servicesList === null || servicesList === void 0 ? void 0 : servicesList.length) && (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pl: 5.25 }, { children: (0, jsx_runtime_1.jsx)(Cell_1.default, { children: "No tools found" }) })), (0, jsx_runtime_1.jsx)("div", { ref: loaderRef })] })), (0, jsx_runtime_1.jsx)(Footer, { isPartialView: !!selectedService, items: servicesList })] }))] })), selectedService && ((0, jsx_runtime_1.jsx)(Preview_1.default, { service: selectedService, onClickClose: function () { return setSelectedServiceId(null); } }, selectedService.id))] }))] }));
};
exports.default = (0, redux_1.compose)(HoCs_1.AuthHoC, react_1.default.memo, function (Component) { return (0, SortHoC_1.default)(Component, { key: 'name', order: 1 }); })(Naming);
